export default {
  en: {
    newBadge: 'New',
    completedBadge: 'Done',
  },
  ru: {
    newBadge: 'Новое',
    completedBadge: 'Пройдено',
  },
  de: {
    newBadge: 'Neu',
    completedBadge: 'Fertig',
  },
  pt: {
    newBadge: 'Novo',
    completedBadge: 'Concluído',
  },
  fr: {
    newBadge: 'Nouveau',
    completedBadge: 'Terminé',
  },
  es: {
    newBadge: 'Nuevo',
    completedBadge: 'Completado',
  },
};
